import { sortByDa } from '../enums';
export const sortDa = (a: any, b: any, aamode: number) => {
    const { AA_FIRST, AA_LAST, AA_ARING } = sortByDa;
    let f;
    aamode = typeof aamode == 'undefined' ? AA_LAST : aamode;
    function intArray(c: any) {
        const array = [];
        c = c.toLowerCase();
        for (let i = 0; i < c.length; i++) {
            if (c.substr(i, 2) === 'aa') {
                switch (aamode) {
                    case AA_FIRST:
                        array.push(0);
                        break;
                    case AA_ARING:
                        array.push(299);
                        break;
                    default:
                        array.push(300);
                        break;
                }
                i = i + 1;
            } else {
                switch (c.charCodeAt(i)) {
                    case 229: //å
                        array.push(299);
                        break;
                    case 248: //ø
                        array.push(298);
                        break;
                    case 230: //æ
                        array.push(297);
                        break;
                    default:
                        array.push(c.charCodeAt(i));
                        break;
                }
            }
        }
        return array;
    }
    const d = intArray(a),
        e = intArray(b);
    for (f = 0; f < d.length; f++) {
        if (d[f] != e[f]) {
            if (f == e.length) {
                return 1; //d has more chars than e
            } else {
                return d[f] - e[f];
            }
        }
    }
    return -1; //e has more chars than d
};
